/** Shown in place of a page or section the admin's role doesn't allow. */
const NoAccess = ({ what = "this page" }) => (
  <div className="w-full pt-5 px-5 font-dmsans">
    <div className="bg-white rounded-lg p-8 text-center">
      <div className="font-bold text-[16px] text-[#070E05]">You don't have access to {what}</div>
      <div className="text-[13px] text-[#00000080] mt-1">Ask an administrator to update your role.</div>
    </div>
  </div>
);

export default NoAccess;
